export default "__VITE_ASSET__EiRw4U5z__"